export enum EExchangeState {
  NOT_EXCHANGING = 'NOT_EXCHANGING',
  ENTER_PASSWORD = 'ENTER_PASSWORD',
  EXCHANGE_IN_FLIGHT = 'EXCHANGE_IN_FLIGHT',
  EXCHANGE_COMPLETE = 'EXCHANGE_COMPLETE',
}

export enum EVideoState {
  LOADING = 'loading',
  OPENING = 'opening',
  REVEALED = 'revealed',
}

export interface ICustomRevealState {
  currentVideoState: EVideoState;
  currentExchangeState: EExchangeState;
  videoBoxType: string;
  shouldLoop: boolean;
  totalCards: number;
  rewards: IExchangeReward[];
  loaded: string[];
  revealed: string[];
  showCards: boolean;
  videoReady: boolean;
}

export interface IExchangeReward {
  name: string;
  game: string;
  image: string;
  quantity: string;
  instance: string;
  collection: string;
  category: string;
  type: string;
  additionalKey: string;
}
